// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__18cKm","header":"ClearentDisclaimer_header__3sb4Z","inner":"ClearentDisclaimer_inner__2TB5H"};